import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import _ from 'lodash';
import {
  IS_LOADING,
  SMS_SEND_MSG,
  SMS_SEND_OTP,
  SMS_VERIFY_OTP,
  SMS_CLEAR
} from './types';
import { SMS_PROVIDER_NAME } from '../configs';

export const smsSend = (phoneNumber, smsMessage, options = {}) => async dispatch => {
  const url = '/sms/send';
  const dataSet = {
    channel: SMS_PROVIDER_NAME,
    phone: phoneNumber,
    message: smsMessage,
    ...options
  };

  dispatch({ type: SMS_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { SMS_SEND_MSG: true } });
  await axios.post(url, dataSet).then(response => {
    let { message } = response.data;
    if (_.has(response.data, 'errors') && response.data.errors.length > 0) {
      message = response.data.errors[0].msg;
    }
    const ref = _.has(response.data, 'data.ref') ? response.data.data.ref : null;
    dispatch({ type: SMS_SEND_MSG, playload: { ref, msg: message, status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { SMS_SEND_MSG: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { SMS_SEND_MSG: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const smsSendOTP = phoneNumber => async dispatch => {
  const url = '/sms/otp';

  dispatch({ type: SMS_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { SMS_SEND_OTP: true } });
  await axios.post(url, { phone: phoneNumber }).then(response => {
    let { message } = response.data;
    if (_.has(response.data, 'errors') && response.data.errors.length > 0) {
      message = response.data.errors[0].msg;
    }
    const ref = _.has(response.data, 'data.ref') ? response.data.data.ref : null;
    dispatch({ type: SMS_SEND_OTP, playload: { ref, msg: message, status: 'success' } });
    dispatch({ type: IS_LOADING, status: false, names: { SMS_SEND_OTP: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { SMS_SEND_OTP: false } });
    dispatch({ type: SMS_SEND_OTP, playload: { msg: error?.response || 'Sorry something went wrong. Please contact support', status: 'success' } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};

export const smsVerifyOTP = (ref, params) => async dispatch => {
  const url = `/sms/otp/verify/${ref}`;

  dispatch({ type: SMS_CLEAR });
  dispatch({ type: IS_LOADING, status: true, names: { SMS_VERIFY_OTP: true } });
  await axios.put(url, params).then(response => {
    let verify = true;
    let { message } = response.data;
    if (_.has(response.data, 'errors') && response.data.errors.length > 0) {
      verify = false;
      message = response.data.errors[0].msg;
    } else if (_.has(response.data, 'error')) {
      verify = false;
    }
    dispatch({
      type: SMS_VERIFY_OTP,
      playload: {
        ref,
        verify,
        msg: message,
        status: 'success'
      }
    });
    dispatch({ type: IS_LOADING, status: false, names: { SMS_VERIFY_OTP: false } });
  }).catch(err => {
    let error = err;
    dispatch({ type: IS_LOADING, status: false, names: { SMS_VERIFY_OTP: false } });
    if ((_.has(error, 'response.status') && error.response.status === 502) || _.isUndefined(error.response)) {
      if (_.isUndefined(error.response)) { error = Error(`502 API at ${url}`); }
      Bugsnag.notify(error);
    }
  });
};
